import * as d3 from "d3";
import AbstractForceGenerator from "./AbstractForceGenerator";

export default class ClusterRepulsiveForceGenerator extends AbstractForceGenerator {
    // Public:
    constructor(cParams) {
        super();
        this.saveParams(cParams);
        this.createStrengthFunction();
    }

    compute() {
        let clusterB = this._clusterB;
        let strengthFunc = this._strengthFunc;
        let force = {
            x: d3.forceX(clusterB.x).strength(strengthFunc),
            y: d3.forceY(clusterB.y).strength(strengthFunc),
        };
        return force;
    }

    // Private:
    saveParams(cParams) {
        this._strength = -cParams.strength;
        this._clusterA = cParams.clusterA;
        this._clusterB = cParams.clusterB;
    }

    createStrengthFunction() {
        let targetCluster = this._clusterA;
        let strength = this.computeStrength();
        let strengthFunc = this.attachToDispatchingFunction(strength, 0);
        let func = function(d) {
            let cluster = d.clusters[0];
            if (cluster.id === targetCluster.id) return strengthFunc(d);
            else return 0;
        };
        this._strengthFunc = func;
    }

    computeStrength() {
        let f = null;
        let F = this._strength;
        let Ra = this._clusterA.radius;
        let Rb = this._clusterB.radius;
        let D = Ra + Rb;
        let d = this.computeDistance();
        let x = d / D;
        if (d < D) f = F * (1 - Math.pow(x, 0.5));
        else f = 0;
        return f;
    }

    computeDistance() {
        let A = this._clusterA;
        let B = this._clusterB;
        let u = A.x - B.x;
        let v = A.y - B.y;
        let d = Math.sqrt(Math.pow(u, 2) + Math.pow(v, 2));
        return d;
    }
}
